module.exports = __webpack_public_path__ + "site/img/94.fc0642d2.jpg";